import AnnualSummaryError from './AnnualSummaryError';
class AnnualSummaryNumberLessThanOne extends AnnualSummaryError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The number of bricks can not be less than one', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default AnnualSummaryNumberLessThanOne;
